import { render, staticRenderFns } from "./Cobrancas.vue?vue&type=template&id=b81e16b8"
import script from "./Cobrancas.vue?vue&type=script&lang=ts"
export * from "./Cobrancas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports